import React from "react";

import { Col, Container, Row } from "react-bootstrap";
import parse from "html-react-parser";

import { selectAllNotices } from "../features/global/globalSlice";
import { useAppSelector } from "../hooks/reduxHooks";

const SiteNotice = (): React.ReactNode => {
    const notices = useAppSelector(selectAllNotices);
    const now = new Date();

    // if there are no notices, return null
    if (
        !notices ||
        notices.every(n => {
            const endOfDay = n ? new Date(n.lastUpdated) : null;
            endOfDay?.setHours(23, 59, 29, 999);

            return (
                n.notice.trim().length === 0 ||
                (endOfDay ? now > endOfDay : false)
            );
        })
    )
        return null;

    return (
        <div id="siteNotice">
            <Container fluid="lg">
                {notices.map(n => {
                    // At this point, there is at least 1 notice to display.
                    // We still need to check the end date for all to see if
                    // any of them have a notice set but it is outdated
                    const endOfDay = n ? new Date(n.lastUpdated) : null;
                    endOfDay?.setHours(23, 59, 29, 999);

                    return (
                        n.notice.trim().length !== 0 &&
                        (endOfDay ? now < endOfDay : false) && (
                            <Row>
                                <Col xs={{ span: 8, offset: 2 }}>
                                    <div className="notice alert alert-warning">
                                        <h5>{n.displayName}</h5>
                                        <div>{parse(n.notice)}</div>
                                    </div>
                                </Col>
                            </Row>
                        )
                    );
                })}
            </Container>
        </div>
    );
};

export default SiteNotice;
